import * as React from 'react'
import { skipToken, useQuery } from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context'

import { useRouteCompanyId } from '@/modules/shared/hooks/useRouteCompanyId'
import { useTaskSync } from '@/modules/shared/hooks/useTaskSync'
import {
  CompanyEffectivePermission,
  ConfigApiAccountResponse,
} from '@/modules/shared/types/account'


export const TaskSyncHost: React.FC = () => {
  const companyId = useRouteCompanyId()
  const sub = useAuth().user?.profile.sub ?? ''
  // Host stoi nad UserProviderem: tylko czytamy jego cache, nic nie pobieramy.
  const { data: account } = useQuery<ConfigApiAccountResponse>({
    queryKey: ['config.user', sub, null],
    queryFn: skipToken,
  })
  const { data: permissions } = useQuery<CompanyEffectivePermission[]>({
    queryKey: ['config.effectivePermissions', sub],
    queryFn: skipToken,
  })
  const isAdmin =
    !!account &&
    (account.globalAdmin || account.paymentAdmin || account.companyAdmin || account.demoCompanyAdmin)
  const own = permissions?.find(
    (p) => String(p.companyConfigurationEntityId).toLowerCase() === companyId?.toLowerCase(),
  )
  // Kierowca bez flag, których wymaga importTask/active (ImportFiles|GeneratePrintouts|EditDelegations), dostałby 403.
  const isDriverWithoutTasks =
    !isAdmin &&
    !!own?.isDriver &&
    !own.canImportFiles &&
    !own.canGeneratePrintouts &&
    !own.canEditDelegations
  useTaskSync(companyId && account && permissions && !isDriverWithoutTasks ? companyId : null)
  return null
}
